<template>
  <div v-on-click-outside="onClickOutside">
    <a
      ref="btnDropdownRef"
      class="text-blueDianne block"
      href="#"
      @click="toggleDropdown"
    >
      <div
        class="items-center flex px-2 py-1"
        :class="{
          'bg-tiara-500 text-white': dropdownPopoverShow,
          'rounded-t-lg': popper?.state?.placement.includes('bottom'),
          'rounded-b-lg': popper?.state?.placement.includes('top'),
        }"
      >
        <i class="fa-solid fa-caret-down"></i>
      </div>
    </a>
    <div
      ref="popoverDropdownRef"
      class="bg-white text-base z-50 float-left list-none text-left rounded-l-lg border-tiara-500 min-w-48 border"
      :class="{
        hidden: !dropdownPopoverShow,
        block: dropdownPopoverShow,
        'rounded-b-lg': popper?.state?.placement.includes('bottom'),
        'rounded-t-lg': popper?.state?.placement.includes('top'),
      }"
    >
      <a
        href="#"
        class="text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-tiara-700 hover:bg-tiara-500 hover:text-white rounded-l rounded-b"
        @click="
          toggleDropdown($event);
          $emit('requestMeeting');
        "
      >
        Request Meeting
      </a>
    </div>
  </div>
</template>

<script>
import { createPopper } from "@popperjs/core";
import { vOnClickOutside } from "@vueuse/components";

export default {
  directives: {
    onClickOutside: vOnClickOutside,
  },
  data() {
    return {
      dropdownPopoverShow: false,
      popper: null,
    };
  },
  beforeUnmount() {
    if (this.popper) {
      this.popper.destroy();
    }
  },
  methods: {
    toggleDropdown(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.dropdownPopoverShow) {
        this.closeDropdown();
      } else {
        this.openDropdown();
      }
    },
    openDropdown() {
      this.dropdownPopoverShow = true;
      this.$nextTick(() => {
        if (this.popper) {
          this.popper.destroy();
        }
        this.popper = createPopper(
          this.$refs.btnDropdownRef,
          this.$refs.popoverDropdownRef,
          {
            placement: "bottom-end",
          },
        );
      });
    },
    closeDropdown() {
      this.dropdownPopoverShow = false;
      if (this.popper) {
        this.popper.destroy();
        this.popper = null;
      }
    },
    onClickOutside() {
      if (this.dropdownPopoverShow) {
        this.closeDropdown();
      }
    },
  },
};
</script>
